module.exports = __webpack_public_path__ + "images/assets/b6609daf315ddb78d7f10864e89f33c2.svg";